export default function InfoCard({
  title,
  subtitle,
  actionLabel,
  onAction,
  loading = false,
  emptyMessage = "No data available",
  children,
  className = "",
}) {
  return (
    <div className={`card border-0 shadow-sm h-100 rounded-4 ${className}`}>
      {/* ===== Header ===== */}
      <div className="card-header bg-white border-0 px-3 px-md-4 pt-3 pt-md-4">
        <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center gap-2">
          <div className="flex-grow-1">
            <h6 className="fw-bold mb-0 text-truncate">{title}</h6>
            {subtitle && (
              <small className="text-muted d-block">{subtitle}</small>
            )}
          </div>

          {actionLabel && (
            <button
              className="btn btn-sm btn-outline-primary rounded-pill px-3 w-100 w-sm-auto"
              onClick={onAction}
            >
              {actionLabel}
            </button>
          )}
        </div>
      </div>

      {/* ===== Body ===== */}
      <div className="card-body px-3 px-md-4 pb-3 pb-md-4 d-flex flex-column">
        {loading ? (
          <div className="d-flex justify-content-center align-items-center py-4 flex-grow-1">
            <div className="spinner-border text-primary" role="status" />
          </div>
        ) : children ? (
          <div className="flex-grow-1">{children}</div>
        ) : (
          <div className="text-muted text-center py-4 flex-grow-1 d-flex align-items-center justify-content-center">
            {emptyMessage}
          </div>
        )}
      </div>
    </div>
  );
}
